import { useAgentHold, setRecallHold, useToast } from '@elva/ui';

/**
 * Holding Recall (amendment 24 §6; unified in specs 36 + 37).
 *
 * The flag lives in the shared AI-Team hold store, so the agent page, the AI
 * Team roster switch, `/recall`'s banner and a reload all agree. The hook
 * subscribes with `useAgentHold` so this page re-renders when the roster holds it.
 */
export function useRecallHold(): { onHold: boolean; setHold: (next: boolean) => void } {
  const hold = useAgentHold('recall');
  const { toast } = useToast();

  return {
    onHold: hold.held,
    setHold: (next: boolean) => {
      setRecallHold(next);
      toast({
        title: next ? 'Recall is on hold' : 'Recall is working again — 46 held messages go at their next window',
        variant: next ? 'warning' : 'success',
      });
    },
  };
}
